import _ from "lodash";
import * as yup from "yup";

import { FORMATS, parse } from "utils/datetime";

import { CompanyFieldFormatType } from "entities/Field/constants";

export const validationSchema = {
  [CompanyFieldFormatType.STRING]: yup.string().nullable(),

  [CompanyFieldFormatType.CURRENCY_USD]: yup
    .string()
    .nullable()
    .test(
      "maxDigitsAfterDecimalPoint",
      "Please enter a valid number. The number can be positive or negative, should contain only digits and up to 2 digits after the decimal point ('.').",
      (value) => {
        if (_.isNil(value)) return true;
        if (isNaN(Number(value))) return false;

        if (value.toString().includes(".")) {
          const strValue = value.toString().split(".");
          return strValue[1].length <= 2 && strValue[1].length !== 0;
        }
        return true;
      }
    ),

  [CompanyFieldFormatType.DATE]: yup
    .date()
    .transform((value, originalValue) => {
      if (originalValue !== "" || _.isNil(originalValue)) {
        if (originalValue.toString().length !== 10) return false;
        return parse(
          originalValue,
          FORMATS.CUSTOM_DATE_PICKER.DATE,
          new Date()
        );
      }
      return null;
    })
    .typeError("Date must be in `MM/DD/YYYY` format.")
    .nullable()
    .test(
      "minAndMaxDateValidation",
      "The date must be between 1/1/1900 and 31/12/2099",
      (value) => {
        if (_.isNil(value)) return true; // Allow null or undefined values
        const minDate = new Date(1900, 0, 1); // January 1, 1900
        const maxDate = new Date(2099, 11, 31); // December 31, 2099
        return value >= minDate && value <= maxDate;
      }
    ),

  [CompanyFieldFormatType.INTEGER]: yup
    .number()
    .nullable()
    .typeError("Value must be a valid whole number.")
    .lessThan(99999999999999, "Value must be less than 100000000000000")
    .transform((value, originalValue) => {
      if (originalValue === "" || _.isNil(originalValue)) {
        return null;
      }
      if (originalValue.toString().includes(".")) {
        return originalValue;
      }
      return Number(originalValue);
    }),

  [CompanyFieldFormatType.FLOAT_2]: yup
    .string()
    .nullable()
    .test(
      "maxDigitsAfterDecimalPoint",
      "Please enter a valid number. The number can be positive or negative, should contain only digits and up to 2 digits after the decimal point ('.').",
      (value) => {
        if (_.isNil(value)) return true;
        if (isNaN(Number(value))) return false;

        if (value.toString().includes(".")) {
          const strValue = value.toString().split(".");
          return strValue[1].length <= 2 && strValue[1].length !== 0;
        }
        return true;
      }
    ),
};

export enum EDatePickeSlideDirections {
  UP = "up",
  DOWN = "down",
  LEFT = "left",
  RIGHT = "right",
}
